/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dimmer, Dropdown, Loader } from "semantic-ui-react";
import { selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import { changeOlderVersionFhirString, selectViewingOlderVersion, viewingOlderVersionOn } from "../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { editModeOff, selectEditMode } from "../slices/editMode/editModeSlice";
import { changeTabFocus } from "../slices/tabPane/tabPaneSlice";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import YesNoRadioCheckBoxSwitch from "../components/YesNoRadioCheckBoxSwitch";
import { getVersionDifference, getHistoryVersionOfResource, loadResourceVersionList } from "../functions/versionDifferencesFunctionsAPI";

const JsonDifferenceWalkthrough = ({ jsonDifferences, previousValue, parentElementName, parentChangeValue }) => {
    if (jsonDifferences && typeof jsonDifferences === "object" && jsonDifferences.CHANGETYPE === undefined && jsonDifferences.VALUE === undefined && jsonDifferences.PREVIOUSVALUE === undefined && Object.keys(jsonDifferences).length && (typeof jsonDifferences[Object.keys(jsonDifferences)[0]] !== "object" || (jsonDifferences[Object.keys(jsonDifferences)[0]] && jsonDifferences[Object.keys(jsonDifferences)[0]].CHANGETYPE === undefined))) {
        let className = "addedJsonDiffValue";
        let previousValueClassName = "deletedJsonDiffValue";
        if (parentChangeValue === "reordered" || parentChangeValue === "reorderedadded" || parentChangeValue === "reorderedandpreviousvaluemoved") {
            className = "reorderedJsonDiffValueString";
        } else if (parentChangeValue === "nochange") {
            className = "nochangeJsonDiffValueString";
        }
        if (parentChangeValue === "previousvaluemoved") {
            className = "changedJsonDiffValueString";
            previousValueClassName = "previousvaluemovedJsonDiffValue";
        } else if (parentChangeValue === "reorderedandpreviousvaluemoved" || parentChangeValue === "deletedpreviousvaluemoved") {
            previousValueClassName = "previousvaluemovedJsonDiffValue";
        }
        return <>
            <span className={className}>
                {JSON.stringify(jsonDifferences, null, 2)}
            </span>
            {previousValue === undefined ? <></> : <><br /><span className={previousValueClassName}>{JSON.stringify(previousValue, null, 2)}</span></>}
        </>
    } else if (jsonDifferences && typeof jsonDifferences === "object" && !Array.isArray(jsonDifferences) && Object.keys(jsonDifferences).length) {
        let jsonDifferencesKeys = Object.keys(jsonDifferences);
        return jsonDifferencesKeys.map((elementName, index) => {
            let element = jsonDifferences[elementName];
            let changeType = element?.CHANGETYPE;
            if (element && (typeof element.VALUE === "object" || typeof element.PREVIOUSVALUE === "object")) {
                let hasCurrentValue = (element && element.VALUE !== undefined &&
                    element.VALUE !== null && typeof element.VALUE === "object" &&
                    (Array.isArray(element.VALUE) ||
                        (!Array.isArray(element.VALUE) && Object.keys(element.VALUE).length)));
                let labelClassName = "nochangeJsonDiffLabel";
                let valueClassName = "nochangeJsonDiffValue";
                if (element.CHANGETYPE !== "nochange") {
                    if (element.CHANGETYPE === "deletedpreviousvaluemoved") {
                        labelClassName = "deletedpreviousvaluemovedJsonDiffLabel";
                        valueClassName = "deletedpreviousvaluemovedJsonDiffValueElement";
                    } else {
                        labelClassName = "deletedJsonDiffLabel";
                        valueClassName = "deletedJsonDiffValue";
                    }
                    //deletedpreviousvaluemoved
                }
                let divClassName = changeType + "JsonDiffValue";
                if (hasCurrentValue) {
                    divClassName = changeType + "JsonDiff";
                }
                if (element.CHANGETYPE === "deletedpreviousvaluemoved") {
                    divClassName = "deletedpreviousvaluemovedJsonDiffValueDiv";
                }
                return <div key={index} className={divClassName}>
                    {hasCurrentValue ?
                        <>
                            <span>
                                {(!isNaN(elementName) && parentElementName) ?
                                    <b>{parentElementName + " " + parseInt(elementName)}: </b>
                                    :
                                    <b>{elementName}: </b>}
                            </span>
                            <div style={{ marginLeft: "24px" }}>
                                <span className={changeType + "JsonDiffValue"}>
                                    <JsonDifferenceWalkthrough jsonDifferences={element.VALUE} previousValue={element.PREVIOUSVALUE} parentElementName={elementName} parentChangeValue={changeType} />
                                </span>

                            </div>
                        </>
                        :
                        <span>{(element && element.PREVIOUSVALUE !== undefined) && <>
                            <span className={labelClassName}>
                                <span>
                                    {(!isNaN(elementName) && parentElementName) ?
                                        <b>{parentElementName + " " + parseInt(elementName)}: </b>
                                        :
                                        <b>{elementName}: </b>}
                                </span>
                            </span>
                            <span className={valueClassName}>
                                {typeof element.PREVIOUSVALUE === "object" ? JSON.stringify(element.PREVIOUSVALUE, null, 2) : element.PREVIOUSVALUE}
                            </span></>}</span>
                    }
                </div>
            } else {
                return <div key={index} className={changeType + "JsonDiff"}><b>{elementName}: </b><span className={changeType + "JsonDiffValue"}>{element.VALUE ?? element.PREVIOUSVALUE} {(element.PREVIOUSVALUE && JSON.stringify(element.VALUE) !== JSON.stringify(element.PREVIOUSVALUE)) && <span className={changeType + "JsonDiffDeleted"}>{element.PREVIOUSVALUE}</span>}</span></div>
            }
        })
    } else {
        //console.log("CRASHING NOW");
        //let x = jsonDifferences.dsa.dsadsa.das.das.dsa.dsa.das.CRASH();
        //console.log(jsonDifferences);
        return <div className={"JsonDiff"}>
            <span className="nochangeJsonDiffValue">{JSON.stringify(previousValue, null, 2)}</span>
        </div>
    }
}

const JsonVersionComparison = ({ jsonDifferences }) => {
    //SERVERCALL
    //const differences = 
    /* return <div className="jsonVersionComparison"><JsonDifferenceWalkthrough jsonDifferences={differenceExample} /></div>*/
    // return <div className="jsonVersionComparison"><JsonDifferenceWalkthrough jsonDifferences={jsonDifferences} /></div>
    if (jsonDifferences && typeof jsonDifferences === "object" && Object.keys(jsonDifferences).length) {
        return <div className="jsonVersionComparison"><JsonDifferenceWalkthrough jsonDifferences={jsonDifferences} /></div>
    } else {
        return <div>There appears to be no difference. (Or this is an error.)</div>
    }
}

const updateVersionDifferencesFunction = async (versionDifferencesInterfaceState,
    setLoadingVersionDifferences, versionListState, foi, apiToken, setVersionDifferencesState
) => {
    let selectedVersionLeft = versionDifferencesInterfaceState.selectedVersionLeft;
    let selectedVersionRight = versionDifferencesInterfaceState.selectedVersionRight;
    if (selectedVersionLeft === selectedVersionRight) {
        //THEY SHOULDN'T BE EQUAL
        console.log("You selected the same version twice. How?");
    } else {
        setLoadingVersionDifferences(true);
        let justTheDifferences = versionDifferencesInterfaceState.justTheDifferences;
        let newVersionNumber;
        let oldVersionNumber;
        if (selectedVersionLeft > selectedVersionRight) {
            newVersionNumber = selectedVersionLeft;
            oldVersionNumber = selectedVersionRight;
        } else {
            newVersionNumber = selectedVersionRight;
            oldVersionNumber = selectedVersionLeft;
        }
        if (versionListState[versionListState.length - newVersionNumber] &&
            versionListState[versionListState.length - oldVersionNumber]) {
            let newHistoryId = versionListState[versionListState.length - newVersionNumber]["historyid"]; //Because reverse order, so for example if there are 64 versions and I selected version 62, 64 - 62 == index 2, version 63 would be index 1, and version 64 would be index 0
            let oldHistoryId = versionListState[versionListState.length - oldVersionNumber]["historyid"];
            let versionDiffJson = await getVersionDifference(foi, newVersionNumber, oldVersionNumber,
                newHistoryId, oldHistoryId, justTheDifferences, apiToken);
            setVersionDifferencesState(versionDiffJson);
        }
        setLoadingVersionDifferences(false);
    }
};

const createDropDownOptions = (latestVersionId, versionListState, versionDifferencesInterfaceState,
    setLeftVersionDifferencesOptionsState, setRightVersionDifferencesOptionsState, setOptionIndexState
) => {
    let leftVersionDifferencesOptions = [];
    let rightVersionDifferencesOptions = [];
    let optionIndex = {};
    if (latestVersionId > 1) {
        let index = 0;
        for (let versionEntry of versionListState) {
            if (versionEntry) {
                let versionNumber = versionEntry.version;
                let datecreated = versionEntry.datecreated;
                let datecreatedTruncated = datecreated.substring(0, 16);
                let text = `${versionNumber}: ${datecreatedTruncated}`; //by ${username}
                let leftOption = {
                    key: versionNumber,
                    value: versionNumber,
                    text: text,
                    disabled: versionDifferencesInterfaceState.selectedVersionRight === versionNumber,
                    selected: versionDifferencesInterfaceState.selectedVersionLeft === versionNumber
                };
                let rightOption = {
                    key: versionNumber,
                    value: versionNumber,
                    text: text,
                    disabled: versionDifferencesInterfaceState.selectedVersionLeft === versionNumber,
                    selected: versionDifferencesInterfaceState.selectedVersionRight === versionNumber
                };
                //let index = fhirEntryState.startingVersionId - versionNumber;
                leftVersionDifferencesOptions[index] = leftOption;
                rightVersionDifferencesOptions[index] = rightOption;
                optionIndex[versionNumber] = index;
            } else {
                console.log("PROBLEM: " + (latestVersionId - index)); //+ " " + index
                leftVersionDifferencesOptions[index] = {
                    key: latestVersionId - index,
                    value: latestVersionId - index,
                    text: "NULL ENTRY",
                    disabled: true,
                    selected: false
                };
                rightVersionDifferencesOptions[index] = {
                    key: latestVersionId - index,
                    value: latestVersionId - index,
                    text: "NULL ENTRY",
                    disabled: true,
                    selected: false
                };
                //optionIndex[latestVersionId - index] = index;
            }
            index++;
        }
    }
    setLeftVersionDifferencesOptionsState(leftVersionDifferencesOptions);
    setRightVersionDifferencesOptionsState(rightVersionDifferencesOptions);
    setOptionIndexState(optionIndex);
};

const showVersionHistory = async (versionListState, setVersionHistoryState, foi, apiToken, setVersionListState) => {
    if (versionListState.length === 0) {
        setVersionHistoryState(prevState => { return { ...prevState, "showButtonClicked": true } });
        let versionList = await loadResourceVersionList(foi, apiToken);
        setVersionHistoryState(prevState => { return { ...prevState, "viewVersions": true } });
        setVersionListState(versionList);
    } else {
        setVersionHistoryState(prevState => { return { ...prevState, "showButtonClicked": true, "viewVersions": true } });
    }
};

const VersionDifferenceViewer = ({ foi }) => {
    //was resourceId, globalContext, fhirEntryState, setFhirEntryState, versionListState, setVersionListState, latestVersionId
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);

    const editMode = useSelector(state => selectEditMode(state));

    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const latestVersionId = parseInt(resourceJson.meta.versionId);
    const [versionIdBeingViewed, setVersionIdBeingViewed] = useState(latestVersionId);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));

    const [versionHistoryState, setVersionHistoryState] = useState({
        "viewVersions": false, "selectedVersion": undefined, "showButtonClicked": false
    });
    const [viewVersionDifferencesState, setViewVersionDifferencesState] = useState({
        "viewDifferences": false, "showButtonClicked": false
    });
    const [versionDifferencesInterfaceState, setVersionDifferencesInterfaceState] = useState({
        "justTheDifferences": true, "selectedVersionLeft": latestVersionId,
        "selectedVersionRight": (latestVersionId - 1)
    });
    const [versionDifferencesState, setVersionDifferencesState] = useState();
    const [loadingVersionDifferences, setLoadingVersionDifferences] = useState(false);
    const [leftVersionDifferencesOptionsState, setLeftVersionDifferencesOptionsState] = useState([]);
    const [rightVersionDifferencesOptionsState, setRightVersionDifferencesOptionsState] = useState([]);
    const [optionIndexState, setOptionIndexState] = useState([]);
    const [versionListState, setVersionListState] = useState([]);

    useEffect(() => {
        if (viewingOlderVersion) {
            console.log(viewingOlderVersion)
            showVersionHistory(versionListState, setVersionHistoryState, foi, apiToken, setVersionListState);
        }
    }, []);

    useEffect(() => {
        if (!versionIdBeingViewed) {
            setVersionIdBeingViewed(resourceJson.meta.versionId); //This is for the intial load if resourceJson wasn't loaded on the first render
        }
    }, [resourceJson.meta.versionId]);

    useEffect(() => {
        if (viewVersionDifferencesState.viewDifferences && versionListState.length) {
            updateVersionDifferencesFunction(versionDifferencesInterfaceState,
                setLoadingVersionDifferences, versionListState, foi, apiToken, setVersionDifferencesState);
        }
    }, [viewVersionDifferencesState.viewDifferences, versionDifferencesInterfaceState, versionListState]);

    useEffect(() => {
        if (versionListState.length && viewVersionDifferencesState.showButtonClicked) {
            createDropDownOptions(latestVersionId, versionListState, versionDifferencesInterfaceState,
                setLeftVersionDifferencesOptionsState, setRightVersionDifferencesOptionsState, setOptionIndexState);
        }
    }, [versionListState, viewVersionDifferencesState.showButtonClicked]);

    return <>
        {(!resourceJson ||
            (versionHistoryState.viewResourceButtonClicked && versionHistoryState.viewVersions)
            || (versionHistoryState.showButtonClicked && !versionHistoryState.viewVersions)
            || (viewVersionDifferencesState.showButtonClicked && !viewVersionDifferencesState.viewDifferences)) &&
            <Dimmer className={"loadingDimmer"} active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        }
        <div className="resourceListHeader" style={{ cursor: "default" }}><div style={{ paddingTop: "20px" }}
            className="resourceListHeaderText"><span>Version History</span></div></div>
        {!versionHistoryState.viewVersions && <>
            <Button className="formButton" style={{ color: "#000000" }} content={"Show Version History"}
                onClick={() => {
                    showVersionHistory(versionListState, setVersionHistoryState, foi, apiToken, setVersionListState);
                }}
                disabled={versionHistoryState.showButtonClicked} />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </>}
        {versionHistoryState.viewVersions &&
            <div>
                <select name="versionHistoryList" size="10" style={{ width: "100%" }}
                    value={versionHistoryState.selectedVersion}
                    onChange={(e) => {
                        setVersionHistoryState(prevState => {
                            return { ...prevState, "selectedVersion": parseInt(e.target.value) }
                        });
                    }}>
                    {versionListState.map((historyEntry, historyIndex) => {
                        let version = historyEntry?.version || "NULL";
                        let datecreated = historyEntry?.datecreated;
                        let username = historyEntry?.username || "Anonymous";
                        return <option value={version} key={historyIndex}
                            disabled={version === versionIdBeingViewed} >
                            {version}: {datecreated} by {username}
                        </option>
                    })}
                </select>
                <Button className="formButton" style={{ color: "#000000" }} content={"View Version"}
                    onClick={async () => {
                        let proceed = true;
                        if (editMode) {
                            proceed = window.confirm("Warning: You're in edit mode any unsaved data will be lost. Do you wish to continue?");
                        }
                        if (proceed) {
                            let selectedVersion = versionHistoryState.selectedVersion;
                            let historyid;
                            try {
                                historyid = versionListState[versionListState.length - selectedVersion]["historyid"]; //Because reverse order, so for example if there are 64 versions and I selected version 62, 64 - 62 == index 2, version 63 would be index 1, and version 64 would be index 0
                            } catch (e) { console.log(e); }
                            //console.log(selectedVersion)
                            //console.log(historyid)
                            //console.log(versionListState)
                            setVersionHistoryState(prevState => { return { ...prevState, "viewResourceButtonClicked": true } });
                            let historyVersionOfResourceResponse = await getHistoryVersionOfResource(foi, selectedVersion, historyid, apiToken);
                            let historyVersionOfResource = historyVersionOfResourceResponse["fhirjsonstring"];
                            let historyVersionOfResourceStatus = historyVersionOfResourceResponse["status"];
                            //KEEPS RECORD OF CURRENT JSON, CURRENT VERSION, AND CURRENT STATUS
                            if (historyVersionOfResourceResponse.warning) {
                                alert(historyVersionOfResourceResponse.warning);
                            }
                            setVersionHistoryState(prevState => {
                                return {
                                    ...prevState,
                                    'selectedVersion': undefined,
                                    'viewingVersion': selectedVersion,
                                    "viewHistoryVersionOfResource": true,
                                    "historyVersionOfResource": historyVersionOfResource,
                                    "historyVersionOfResourceStatus": historyVersionOfResourceStatus,
                                    "viewResourceButtonClicked": false,
                                    "currentVersion": latestVersionId
                                }
                            });
                            setVersionDifferencesInterfaceState(prevState => { return { ...prevState, "selectedVersionRight": selectedVersion } });
                            dispatch(viewingOlderVersionOn());
                            dispatch(changeOlderVersionFhirString(historyVersionOfResource));
                            dispatch(editModeOff());
                            dispatch(changeTabFocus("Text View"));
                        }
                    }} disabled={!versionHistoryState.selectedVersion || versionHistoryState.viewResourceButtonClicked} />
            </div>
        }
        {!viewVersionDifferencesState.viewVersions &&
            <>
                {versionHistoryState.viewVersions && <br />}
                {!viewVersionDifferencesState.viewDifferences &&
                    <Button className="formButton"
                        style={{ color: "#000000" }}
                        content={"Show Version Differences"}
                        onClick={async () => {
                            if (versionListState.length === 0) {
                                setViewVersionDifferencesState(prevState => { return { ...prevState, "showButtonClicked": true } });
                                let versionList = await loadResourceVersionList(foi, apiToken);
                                setViewVersionDifferencesState(prevState => { return { ...prevState, "viewDifferences": true } });
                                setVersionListState(versionList);
                            } else {
                                setViewVersionDifferencesState(prevState => { return { ...prevState, "showButtonClicked": true, "viewDifferences": true } });
                            }
                        }}
                        disabled={viewVersionDifferencesState.showButtonClicked} />}
            </>
        }
        {viewVersionDifferencesState.viewDifferences &&
            <>
                <br /><br />
                <Dropdown
                    name="versionDifferencesOne"
                    placeholder=""
                    closeOnChange selection selectOnBlur={false} autoComplete="off"
                    style={{ width: "200px" }}
                    options={leftVersionDifferencesOptionsState}
                    value={versionDifferencesInterfaceState.selectedVersionLeft}
                    onChange={(e, data) => {
                        setVersionDifferencesInterfaceState(prevInterfaceState => {
                            setLeftVersionDifferencesOptionsState(prevstate => {
                                let newState = JSON.parse(JSON.stringify(prevstate));
                                newState[optionIndexState[versionDifferencesInterfaceState.selectedVersionLeft]]["selected"] = false;
                                newState[optionIndexState[data.value]]["selected"] = true;
                                return [...newState];
                            });
                            setRightVersionDifferencesOptionsState(prevstate => {
                                let newState = JSON.parse(JSON.stringify(prevstate));
                                newState[optionIndexState[versionDifferencesInterfaceState.selectedVersionLeft]]["disabled"] = false;
                                newState[optionIndexState[data.value]]["disabled"] = true;
                                return [...newState];
                            });
                            return { ...prevInterfaceState, "selectedVersionLeft": parseInt(data.value) }
                        });
                    }}
                    disabled={false}
                />
                &nbsp;&nbsp;<i>vs.</i>&nbsp;&nbsp;
                <Dropdown
                    name="versionDifferencesTwo"
                    placeholder=""
                    closeOnChange selection selectOnBlur={false} autoComplete="off"
                    style={{ width: "200px" }}
                    options={rightVersionDifferencesOptionsState}
                    value={versionDifferencesInterfaceState.selectedVersionRight}
                    onChange={(e, data) => {
                        setVersionDifferencesInterfaceState(prevInterfaceState => {
                            setRightVersionDifferencesOptionsState(prevstate => {
                                let newState = JSON.parse(JSON.stringify(prevstate));
                                newState[optionIndexState[versionDifferencesInterfaceState.selectedVersionRight]]["selected"] = false;
                                newState[optionIndexState[data.value]]["selected"] = true;
                                return [...newState];
                            });
                            setLeftVersionDifferencesOptionsState(prevstate => {
                                let newState = JSON.parse(JSON.stringify(prevstate));
                                newState[optionIndexState[versionDifferencesInterfaceState.selectedVersionRight]]["disabled"] = false;
                                newState[optionIndexState[data.value]]["disabled"] = true;
                                return [...newState];
                            });
                            return { ...prevInterfaceState, "selectedVersionRight": parseInt(data.value) }
                        });
                    }}
                    disabled={false}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <YesNoRadioCheckBoxSwitch elementName={"justTheDifferences"}
                    labelElementName={"Only show the differences?"}
                    flatElementValue={true} togglable={false} thin={true} fontSize={"14px"}
                    alternativeValues={[true, false]}
                    alternativeLabels={["Just the Differences", "Full JSON"]}
                    startingValue={versionDifferencesInterfaceState.justTheDifferences}
                    setter={setVersionDifferencesInterfaceState} />
                <div>
                    {loadingVersionDifferences &&
                        <Dimmer className={"loadingDimmer"} active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>}
                    <br />
                    {versionDifferencesState && <JsonVersionComparison jsonDifferences={versionDifferencesState} />}
                </div>
            </>
        }
    </>
}

export { VersionDifferenceViewer };